if (!customElements.get('nwt-neckl-charms')) {
  class nwtNeckLCharms extends HTMLElement {
    constructor() {
      super();

      const STORAGE_KEY = 'atelier-charm-config-v1';

      this.catalog = [];
      this.numCharms = this.parseCount(this.dataset.defCount);
      this.selectedCharms = [];
      this.activeSlot = null;

      this.addLabel = this.dataset.addLabel;
      this.changeLabel = this.dataset.changeLabel;
      this.CHARMS_URL = this.dataset.chrUrl;
      this.lineItProp = this.dataset.lineItemProperty;
      this.prodForm = this.dataset.productForm;
      this.STORAGE_KEY = STORAGE_KEY;
      this.DEFAULT_COUNT = this.parseCount(this.dataset.defCount);

      this.productInfo = null;
      this.statusText = null;
      this.continueBtn = null;
      this.modalOverlay = null;
      this.modalGrid = null;
      this.modalClose = null;

      this.pillSelector = null;
      this.necklaceSection = null;
      this.necklaceSvg = null;
      this.previewCaption = null;
      this.charmStep = null;
      this.charmTrack = null;

      this.empyText = '';
      this.qtyText = '';

      this._mo = null;
      this._staticAbort = null;
      this._keydownBound = null;
      this._initialized = false;
      this._initializing = false;

      this.onChange = this.onChange.bind(this);
      this.colorData = {};
      this.currentColorItems = [];
      this.isCatalogLoaded = false;
    }

    parseCount(value) {
      const n = Number(value);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
    }

    listenColorChange() {
      document.addEventListener('color-change', (e) => {
        const swatch = e.detail.radio.closest('variant-selects');
        if (!swatch || !this.productInfo?.contains(swatch)) {
          return;
        }

        const color = e.detail.radio?.dataset.colorLabel;

        if(!color) return;


        let isColorChanged = this.updateCurrentColor(color);
        // console.log('--- color ',color, ' isColorChanged: ',isColorChanged);

        if(isColorChanged) {

          if(!this.isCatalogLoaded) {
            this.addEventListener('catalog-loaded', () => {
              // console.log('catalog loaded');
              
              this.propagateColorChange(color);
            })

          } else {
            this.propagateColorChange(color);
          }
        }
      });
    }

    updateCurrentColor(newColor) {
      if (this.colorData.currentColor === undefined) {
        // console.log('current not defined');
        
        return true;
      }

      const hasPreviousColor = this.colorData.currentColor != null;

      this.colorData.prevColor = this.colorData.currentColor;
      this.colorData.currentColor = newColor;

      const isColorChanged =
        hasPreviousColor &&
        this.colorData.prevColor !== this.colorData.currentColor;

      // console.log(
      //   isColorChanged,
      //   this.colorData.prevColor,
      //   this.colorData.currentColor
      // );

      return isColorChanged;
    }



    propagateColorChange(color = this.colorData.currentColor) {
      // console.log('**** propagateColorChange', color);

      if (!color) {
        return;
      }

      const colors = this.catalog?.colors;

      if (!Array.isArray(colors)) {
        console.warn(
          'propagateColorChange: catalogo colori non disponibile.'
        );
        // console.log('colors > ',colors);
        
        return;
      }

      /*
      * Il color ricevuto da listenColorChange()
      * deve corrispondere ESATTAMENTE all'attributo
      * "color" di uno degli oggetti del catalogo.
      */
      const matchingColor = colors.find(
        (colorData) => colorData?.color === color
      );

      /*
      * Nessuna corrispondenza:
      * non modifichiamo assolutamente nulla.
      */
      if (!matchingColor) {
        console.warn(
          `propagateColorChange: nessuna corrispondenza per "${color}".`
        );
        return;
      }

      /*
      * Il nuovo catalogo del colore deve contenere items.
      *
      * Se non li contiene, manteniamo quello precedente per evitare
      * di svuotare la preview.
      */
      if (!Array.isArray(matchingColor.items)) {
        console.warn(
          `propagateColorChange: nessun catalogo charm valido per "${color}".`
        );
        return;
      }

      /*
      * Da questo momento questo è il catalogo attivo.
      *
      * NON modifichiamo l'ordine di this.catalog.colors.
      */
      this.currentColorItems = matchingColor.items;

      /*
      * Aggiorniamo i charm già presenti nella configurazione.
      *
      * L'ID identifica lo stesso charm nelle diverse varianti colore.
      */
      const itemsById = new Map(
        this.currentColorItems
          .filter((item) => item?.id)
          .map((item) => [item.id, item])
      );

      // console.log('selected charms: ', this.selectedCharms,' colors ',colors);
      

      this.selectedCharms = this.selectedCharms.map((selectedCharm) => {
        // console.log('selected charm: ', selectedCharm);
        
        
        if (!selectedCharm) {
          return null;
        }

        if (!selectedCharm.id) {
          return selectedCharm;
        }

        const colorKey = this.colorData.prevColor;
        let newId;

        const relatedColorFound = colors.find(colorData =>
          colorData.items?.some(item => item.id === selectedCharm.id)
        )?.color;

        // console.log(color);

        if(colorKey) {
          newId = selectedCharm.id.replace(colorKey, this.colorData.currentColor)
        } else {
          // bisogna costruire l'id da zero
          newId = selectedCharm.id.replace(relatedColorFound, this.colorData.currentColor)
        }
        const updatedCharm = itemsById.get(newId);
        // console.log(relatedColorFound,selectedCharm.id,selectedCharm.charmColor,this.colorData ,this.colorData.prevColor, this.colorData.currentColor, newId, updatedCharm);
        

        
        if (updatedCharm) {
          return updatedCharm;
        }

        
        return selectedCharm;
      });

      /*
      * Aggiorniamo solo la preview.
      *
      * Numero, ordine e slot rimangono invariati.
      */
      this.renderCharmTrack();
      this.renderNecklace();

      this.saveConfig();

      // console.log(
      //   '----- color propagated',
      //   {
      //     color,
      //     selectedCharms: this.selectedCharms,
      //     currentColorItems: this.currentColorItems
      //   }
      // );
    }

    connectedCallback() {
      // console.log('----- connectedCallback');

      this.productInfo = this.closest('product-info');
      this.empyText = this.dataset.emptyHelpText || '';
      this.qtyText = this.dataset.qtyHelpText || '';

      this.addEventListener('change', this.onChange);

      this.bindKeydownListener();
      this.init();
      // this.refreshReferences();
      this.observeVariantSwap();

      this.listenColorChange();

      document.addEventListener('nwt_product:rendered', (e) => {
        this.bindCtaWarning(e);
      });
      
    }


    disconnectedCallback() {
      this._mo?.disconnect();
      this._mo = null;

      this._staticAbort?.abort();
      this._staticAbort = null;

      if (this._keydownBound) {
        document.removeEventListener('keydown', this._keydownBound);
        this._keydownBound = null;
      }

      this.removeEventListener('change', this.onChange);

      this._initialized = false;
      this._initializing = false;
    }

    refreshReferences() {
      // console.log('---- refreshReferences');

      const variantSelectNode = this.querySelector('variant-selects');

      this.pillSelector = variantSelectNode?.querySelector('.chr-num-selector') || null;
      this.necklaceSection = this.querySelector('#necklacePreview');
      this.necklaceSvg = this.querySelector('#necklaceSvg');
      this.previewCaption = this.querySelector('#previewCaption');
      this.charmStep = this.querySelector('#charmStep');
      this.charmTrack = this.querySelector('#charmTrack');

      this.productInfo = this.closest('product-info');

      this.statusText = this.productInfo?.querySelector('#statusText') || null;
      this.continueBtn = this.productInfo?.querySelector('#continueBtn') || null;

      this.modalOverlay =
        this.productInfo?.querySelector('#modalOverlay') ||
        this.querySelector('#modalOverlay') ||
        null;

      this.modalGrid =
        this.productInfo?.querySelector('#modalGrid') ||
        this.querySelector('#modalGrid') ||
        null;

      this.modalClose =
        this.productInfo?.querySelector('#modalClose') ||
        this.querySelector('#modalClose') ||
        null;

      const checkedColorHex = variantSelectNode?.querySelector('fieldset.color-selection-set .input-swatch-custom:checked').dataset.color;
      if(checkedColorHex) this.style.setProperty('--gold-line',checkedColorHex)

      // console.log('....... references:', {
      //   variantSelectNode,
      //   pillSelector: this.pillSelector,
      //   charmTrack: this.charmTrack,
      //   necklaceSvg: this.necklaceSvg
      // });

      this.updateLineItemProperty();


      this.bindStaticListeners();
    }


    updateLineItemProperty() {
      const hidInput = this.productInfo.querySelector('input#nwtChrNeckl_LIP');

      let toCreate = false;
      if (!hidInput) toCreate = true;

      if (toCreate) {
        const inp = document.createElement('input');
        inp.name = `properties[${this.lineItProp}]`;
        inp.id = 'nwtChrNeckl_LIP';
        inp.setAttribute('form',this.prodForm);
        inp.className = 'visually-hidden';
        inp.value = this.buildHiddenInputValue();

        this.productInfo.appendChild(inp);
      } else {
        hidInput.value = this.buildHiddenInputValue();
      }
    }

    buildHiddenInputValue() {
      const charms = this.selectedCharms?.filter(c => c?.name) ?? [];

      const val = charms
        .map(c => c.name)
        .join(', ') + (charms.length ? '.' : '');

      // console.log('///    --> ', val);
      return val;
    }

    observeVariantSwap() {
      this._mo?.disconnect();

      this._mo = new MutationObserver((mutations) => {
        const variantSelectsChanged = mutations.some((mutation) => {
          const addedVariantSelects = [...mutation.addedNodes].some((node) => {
            return (
              node.nodeType === Node.ELEMENT_NODE &&
              (
                node.matches?.('variant-selects') ||
                node.querySelector?.('variant-selects')
              )
            );
          });

          const removedVariantSelects = [...mutation.removedNodes].some((node) => {
            return (
              node.nodeType === Node.ELEMENT_NODE &&
              (
                node.matches?.('variant-selects') ||
                node.querySelector?.('variant-selects')
              )
            );
          });

          return addedVariantSelects || removedVariantSelects;
        });

        if (!variantSelectsChanged) {
          return;
        }

        // console.log('----- variant-selects changed');

        queueMicrotask(() => {
          if (!this.isConnected) {
            return;
          }

          this.refreshReferences();
          this.activatePillUI(this.numCharms);

          if (
            this.charmTrack &&
            this.charmTrack.childElementCount !== this.selectedCharms.length
          ) {
            this.renderCharmTrack();
          }

          this.renderNecklace();
        });
      });

      this._mo.observe(this, {
        childList: true,
        subtree: true
      });
    }

    bindStaticListeners() {
      this._staticAbort?.abort();
      this._staticAbort = new AbortController();

      const { signal } = this._staticAbort;

      if (this.modalClose) {
        this.modalClose.addEventListener(
          'click',
          () => this.closeModal(),
          { signal }
        );
      }

      if (this.modalOverlay) {
        this.modalOverlay.addEventListener(
          'click',
          (e) => {
            if (e.target === this.modalOverlay) {
              this.closeModal();
            }
          },
          { signal }
        );
      }
    }

    bindKeydownListener() {
      if (this._keydownBound) {
        return;
      }

      this._keydownBound = (e) => {
        if (
          e.key === 'Escape' &&
          this.modalOverlay &&
          !this.modalOverlay.hidden
        ) {
          this.closeModal();
        }
      };

      document.addEventListener('keydown', this._keydownBound);
    }

    saveConfig() {
      try {
        const payload = JSON.stringify({
          numCharms: this.numCharms,
          selectedCharms: this.selectedCharms
        });

        // console.log('$$$ SALVATO IN STORAGE -> ',payload);
        

        window.localStorage.setItem(this.STORAGE_KEY, payload);
      } catch (e) {
        console.warn(
          'Impossibile salvare la configurazione in localStorage.',
          e
        );
      }
    }

    loadConfig() {
      try {
        const raw = window.localStorage.getItem(this.STORAGE_KEY);

        // console.log('€€€ configurazione letta ',raw);
        

        if (!raw) {
          return null;
        }

        const parsed = JSON.parse(raw);

        if (
          !parsed ||
          !Number.isFinite(Number(parsed.numCharms)) ||
          !Array.isArray(parsed.selectedCharms)
        ) {
          return null;
        }

        return {
          numCharms: this.parseCount(parsed.numCharms),
          selectedCharms: parsed.selectedCharms
        };
      } catch (e) {
        console.warn(
          'Configurazione salvata non leggibile, verrà ignorata.',
          e
        );

        return null;
      }
    }

    onChange(e) {
      const input = e.target.closest?.('.nwt-pills-input');

      if (!input || !this.contains(input)) {
        return;
      }

      const value = input.dataset.value ?? input.value;
      const count = this.parseCount(value);

      // console.log('----- charm count changed', {
      //   rawValue: value,
      //   count
      // });

      this.selectCount(count);
    }

    async loadCatalog() {
      const res = await fetch(this.CHARMS_URL);
      // console.log('caricamento catalogo completato');
      
      if (!res.ok) {
        throw new Error(
          `Impossibile leggere ${this.CHARMS_URL} (status ${res.status})`
        );
      }

      return res.json();
    }

    async init() {
      if (this._initializing || this._initialized) {
        return;
      }

      this._initializing = true;

      let saved = null;

      try {
        this.refreshReferences();

        try {
          this.catalog = await this.loadCatalog();

          
          
          
          const initialColor = this.productInfo
          ?.querySelector('variant-selects')
          ?.querySelector('input[data-color-label]:checked')
          ?.dataset.colorLabel;
          
          
          
          if (initialColor) {
            const initialColorData = this.catalog?.colors?.find(
              (colorData) => colorData?.color === initialColor
            );
            
            // console.log('+++ YES COLOR DATA ',initialColor, initialColorData);
            
            
            if (initialColorData && Array.isArray(initialColorData.items)) {
              this.colorData.currentColor = initialColor;
              this.currentColorItems = initialColorData.items;
            }
          }
          saved = this.loadConfig();
        } catch (e) {
          console.error(e);

          if (this.statusText) {
            this.statusText.textContent =
              'Impossibile caricare il catalogo dei charm.';
          }

          return;
        }

        if (!this.isConnected) {
          return;
        }

        // this.refreshReferences();

        

        if (saved) {
          this.numCharms = this.parseCount(saved.numCharms);
          this.selectedCharms = this.normalizeSelection(
            saved.selectedCharms,
            this.numCharms
          );
          // console.log('1. ', this.selectedCharms);
          
        } else {
          this.numCharms = this.DEFAULT_COUNT;
          this.selectedCharms = new Array(this.numCharms).fill(null);
        }

        this.dispatchEvent(
            new CustomEvent('catalog-loaded', {
              detail: {
                catalog: this.catalog
              }
            })
          );
        this.isCatalogLoaded = true;

        this.bindCtaWarning();        
        this.updateLineItemProperty();
        this.activatePillUI(this.numCharms);

        if (this.necklaceSection) {
          this.necklaceSection.hidden = false;
        }

        this.renderCharmTrack();
        this.renderNecklace();
        this.updateFooter();
        this.saveConfig();

        this._initialized = true;
      } finally {
        this._initializing = false;
      }
    }

    normalizeSelection(saved, n) {
      const count = this.parseCount(n);
      const arr = new Array(count).fill(null);
      const catalogItems =  this.currentColorItems || [];

      for (let i = 0; i < count; i++) {
        const c = saved?.[i];

        if (!c || !c.id) {
          continue;
        }

        const found = catalogItems.find((item) => item.id === c.id);

        // console.log('NORMALIZE:', {
        //   savedCharm: c,
        //   savedCharmColor: c.charmColor,
        //   found,
        //   currentColor: this.colorData.currentColor,
        //   currentColorItems: catalogItems
        // });


        
        // arr[i] = found || c;
        arr[i] = found ? {
            ...found,
            charmColor: c.charmColor ?? this.colorData.currentColor
          }
        : c;
      }
      // console.log('\\\\** normalize selection ---> ',arr);
      
      return arr;
    }

    buildPillSelector() {
      if (!this.pillSelector) {
        return;
      }

      const checked = this.pillSelector.querySelector('.nwt-pills-input:checked');

      // console.log('.... buildPillSelector', {
      //   selector: this.pillSelector,
      //   checkedValue: checked?.dataset.value
      // });

      this.activatePillUI(this.numCharms);
    }

    activatePillUI(n) {
      if (!this.pillSelector) {
        return;
      }

      const count = this.parseCount(n);
      const inputs = this.pillSelector.querySelectorAll('.nwt-pills-input');

      inputs.forEach((input) => {
        const inputValue = this.parseCount(
          input.dataset.value ?? input.value
        );

        const checked = inputValue === count;

        if (
          input instanceof HTMLInputElement &&
          (input.type === 'radio' || input.type === 'checkbox')
        ) {
          input.checked = checked;
        }

        input.setAttribute(
          'aria-checked',
          checked ? 'true' : 'false'
        );

        const pill = input.closest('.nwt-pill');

        if (pill) {
          pill.setAttribute(
            'aria-checked',
            checked ? 'true' : 'false'
          );
        }
      });
    }

    selectCount(n) {
      const count = this.parseCount(n);

      const previous = Array.isArray(this.selectedCharms)
        ? this.selectedCharms
        : [];

      this.numCharms = count;

      this.selectedCharms = new Array(count)
        .fill(null)
        .map((_, i) => previous[i] || null);

      // console.log('----- selectCount', {
      //   n: count,
      //   length: this.selectedCharms.length,
      //   array: [...this.selectedCharms]
      // });

      this.activatePillUI(count);

      if (this.necklaceSection) {
        this.necklaceSection.hidden = false;
      }

      this.renderCharmTrack();
      this.renderNecklace();
      this.updateFooter();
      this.saveConfig();
      // this.bindCtaWarning();
    }

    bindCtaWarning(e) {

      if(e) {
        if(!this.productInfo.dataset.section == e?.detail?.instanceId) {
          // console.log('-----> return ',this.productInfo.dataset.section, e?.detail?.instanceId);
          return;
        }
      }
      const atcBtn = this.productInfo.querySelector('.product-form__submit');
      const ctaWarningDesc = atcBtn?.querySelector('.gcd-atc-blocked');

      
      const needToShow = !this.selectedCharms.every(Boolean);
      // console.log(this.selectedCharms,' need to show: ',needToShow, ' e -> ',e?.detail?.instanceId);


      if(needToShow) {

        if(!ctaWarningDesc) {
          const span = document.createElement('span');
          span.classList.add('alt-font', 't-center', 'gcd-atc-blocked');
          span.innerText = this.dataset.atcLabel;
  
          atcBtn.appendChild(span);
        }

        atcBtn.classList.add('flex-col', 'align-it-center');
        atcBtn.disabled = true;
      } 
      else if (!needToShow) {
        atcBtn.classList.remove('flex-col', 'align-it-center');
        atcBtn.disabled = false;
        if(atcBtn.querySelector('.gcd-atc-blocked')) atcBtn.removeChild(atcBtn.querySelector('.gcd-atc-blocked'));
      }
    }


//     bindCtaWarning() {
//   const atcBtn = this.productInfo.querySelector('.product-form__submit');
//   if (!atcBtn) return;

//   const needToShow = !this.selectedCharms.every(Boolean);

//   // Crea il listener una sola volta
//   if (!this.onProductRendered) {
//     this.onProductRendered = (event) => {
//       if (event.detail.instanceId !== this.instanceId) return;

//       // Lo stile viene applicato SOLO dopo aver ricevuto l'evento
//       atcBtn.classList.add('flex-col', 'align-it-center');
//       atcBtn.disabled = true;
//     };
//   }

//   if (needToShow) {
//     document.addEventListener(
//       'nwt_product:rendered',
//       this.onProductRendered
//     );

//     if (!atcBtn.querySelector('.gcd-atc-blocked')) {
//       const span = document.createElement('span');
//       span.classList.add('alt-font', 't-center', 'gcd-atc-blocked');
//       span.innerText = this.dataset.atcLabel;

//       atcBtn.appendChild(span);
//     }

//   } else {
//     document.removeEventListener(
//       'nwt_product:rendered',
//       this.onProductRendered
//     );

//     const span = atcBtn.querySelector('.gcd-atc-blocked');

//     atcBtn.disabled = false;
//     atcBtn.classList.remove('flex-col', 'align-it-center');

//     if (span) span.remove();
//   }
// }

    renderCharmTrack() {
      if (!this.charmTrack) {
        console.warn('renderCharmTrack: #charmTrack non trovato.');
        return;
      }

      this.charmTrack.innerHTML = '';

      // console.log(
      //   '----- renderCharmTrack',
      //   this.selectedCharms.length,
      //   this.selectedCharms
      // );

      this.selectedCharms.forEach((charm, index) => {
        const card = document.createElement('div');
        card.className = 'charm-card';
        card.dataset.index = String(index);

        const label = document.createElement('p');
        label.className = 'slot-label';
        label.textContent = `Posizione ${index + 1}`;
        card.appendChild(label);

        if (charm) {
          const img = document.createElement('img');
          img.className = 'charm-thumb';
          img.src = charm.image;
          img.alt = charm.name || '';
          card.appendChild(img);

          const name = document.createElement('p');
          name.className = 'charm-name';
          name.textContent = charm.name || '';
          card.appendChild(name);

          const changeBtn = document.createElement('button');
          changeBtn.type = 'button';
          changeBtn.className = 'change-link';
          // changeBtn.textContent = 'Cambia';
          changeBtn.textContent = this.changeLabel;

          changeBtn.addEventListener('click', () => {
            this.openModal(index);
          });

          card.appendChild(changeBtn);
        } else {
          const addBtn = document.createElement('button');
          addBtn.type = 'button';
          addBtn.className = 'add-charm-btn';
          addBtn.setAttribute(
            'aria-label',
            `Scegli il charm per la posizione ${index + 1}`
          );
          addBtn.textContent = '+';

          addBtn.addEventListener('click', () => {
            // console.log('--> addBtn click');
            
            this.openModal(index);
          });

          card.appendChild(addBtn);

          const hint = document.createElement('p');
          hint.className = 'charm-name charm-name--muted';
          // hint.textContent = 'Aggiungi';
          hint.textContent = this.addLabel;
          card.appendChild(hint);
        }

        const leftBtn = document.createElement('button');
        leftBtn.type = 'button';
        leftBtn.className = 'reorder-btn';
        leftBtn.setAttribute('aria-label', 'Sposta a sinistra');
        leftBtn.textContent = '‹';
        leftBtn.disabled = index === 0;

        leftBtn.addEventListener('click', () => {
          this.moveCharm(index, -1);
        });

        const rightBtn = document.createElement('button');
        rightBtn.type = 'button';
        rightBtn.className = 'reorder-btn';
        rightBtn.setAttribute('aria-label', 'Sposta a destra');
        rightBtn.textContent = '›';
        rightBtn.disabled = index === this.selectedCharms.length - 1;

        rightBtn.addEventListener('click', () => {
          this.moveCharm(index, 1);
        });

        const orderBtnWrapper = document.createElement('div');
        orderBtnWrapper.classList.add('flex','align-it-center','just-center','reoder-btn-wr');

        orderBtnWrapper.appendChild(leftBtn);
        orderBtnWrapper.appendChild(rightBtn);

        card.appendChild(orderBtnWrapper);

        this.charmTrack.appendChild(card);
      });

      // console.log('renderCharmTrack completed', this.charmTrack);
    }

    moveCharm(index, delta) {
      const target = index + delta;

      if (
        target < 0 ||
        target >= this.selectedCharms.length
      ) {
        return;
      }

      [
        this.selectedCharms[index],
        this.selectedCharms[target]
      ] = [
        this.selectedCharms[target],
        this.selectedCharms[index]
      ];

      this.renderCharmTrack();
      this.renderNecklace();
      this.saveConfig();
    }

    openModal(slotIndex) {
      if (!this.modalGrid || !this.modalOverlay) {
        console.warn('openModal: elementi modal non trovati.');
        return;
      }

      if (
        slotIndex < 0 ||
        slotIndex >= this.selectedCharms.length
      ) {
        return;
      }

      this.activeSlot = slotIndex;
      this.modalGrid.innerHTML = '';

      const currentCharm = this.selectedCharms[slotIndex];
      const catalogItems = this.currentColorItems || [];
      const groups = [];

      catalogItems.forEach((charm) => {
        let group = groups.find(
          (group) => group.category === charm.category
        );

        if (!group) {
          group = {
            category: charm.category,
            charms: []
          };

          groups.push(group);
        }

        group.charms.push(charm);
      });

      groups.forEach((group) => {
        const groupEl = document.createElement('div');
        groupEl.className = 'modal-charm-group';

        const legend = document.createElement('div');
        legend.className = 'modal-charm-legend alt-font';
        legend.textContent = group.category || '';
        groupEl.appendChild(legend);

        const grid = document.createElement('div');
        grid.className = 'modal-charm-grid';

        group.charms.forEach((charm) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'modal-charm';

          item.setAttribute(
            'aria-pressed',
            currentCharm && currentCharm.id === charm.id
              ? 'true'
              : 'false'
          );

          item.addEventListener('click', () => {
            this.chooseCharm(charm);
          });

          const img = document.createElement('img');
          img.src = charm.image;
          img.alt = charm.name || '';
          item.appendChild(img);

          const name = document.createElement('p');
          name.className = 'modal-charm-name';
          name.textContent = charm.name || '';
          item.appendChild(name);

          grid.appendChild(item);
        });

        groupEl.appendChild(grid);
        this.modalGrid.appendChild(groupEl);
      });

      this.modalOverlay.hidden = false;
    }

    chooseCharm(charm) {
      if (
        this.activeSlot === null ||
        this.activeSlot < 0 ||
        this.activeSlot >= this.selectedCharms.length
      ) {
        return;
      }

      // this.selectedCharms[this.activeSlot] = charm;

       this.selectedCharms[this.activeSlot] = {
        ...charm,
        charmColor: this.colorData.currentColor
      };

      this.closeModal();
      this.bindCtaWarning();
      this.renderCharmTrack();
      this.renderNecklace();
      this.updateFooter();
      this.saveConfig();
      this.updateLineItemProperty();
    }

    closeModal() {
      if (this.modalOverlay) {
        this.modalOverlay.hidden = true;
      }

      this.activeSlot = null;
    }

    bezierPoint(t, p0, p1, p2, p3) {
      const mt = 1 - t;

      const x =
        mt ** 3 * p0[0] +
        3 * mt ** 2 * t * p1[0] +
        3 * mt * t ** 2 * p2[0] +
        t ** 3 * p3[0];

      const y =
        mt ** 3 * p0[1] +
        3 * mt ** 2 * t * p1[1] +
        3 * mt * t ** 2 * p2[1] +
        t ** 3 * p3[1];

      return [x, y];
    }

    renderNecklace() {
      if (!this.necklaceSvg || !this.previewCaption) {
        return;
      }

      // console.log('.... render neckl');
      

      const p0 = [40, 40];
      const p1 = [210, 190];
      const p2 = [430, 190];
      const p3 = [600, 40];

      const pinRadius = this.numCharms >= 6 ? 20 : 24;
      const tStart = 0.16;
      const tEnd = 0.84;

      let pinsMarkup = '';
      let defsMarkup = '';

      this.selectedCharms.forEach((charm, index) => {
        const t = this.numCharms === 1
          ? 0.5
          : tStart + ((tEnd - tStart) * index) / (this.numCharms - 1);

        const [x, y] = this.bezierPoint(
          t,
          p0,
          p1,
          p2,
          p3
        );

        const clipId = `clip-${index}`;

        if (charm) {
          defsMarkup += `
            <clipPath id="${clipId}">
              <circle
                cx="${x}"
                cy="${y}"
                r="${pinRadius}"
              />
            </clipPath>
          `;

          pinsMarkup += `
            <g class="charm-pin-image">
              <image
                href="${charm.image}"
                x="${x - pinRadius}"
                y="${y - pinRadius}"
                width="${pinRadius * 2}"
                height="${pinRadius * 2}"
                clip-path="url(#${clipId})"
                preserveAspectRatio="xMidYMid slice"
              />
            </g>
          `;
        } else {
          pinsMarkup += `
            <circle
              class="charm-pin-empty"
              cx="${x}"
              cy="${y}"
              r="${pinRadius}"
            />
          `;
        }
      });

      this.necklaceSvg.innerHTML = `
        <defs>
          ${defsMarkup}
        </defs>

        <path
          class="chain-path"
          d="M ${p0[0]},${p0[1]}
             C ${p1[0]},${p1[1]}
               ${p2[0]},${p2[1]}
               ${p3[0]},${p3[1]}"
        />

        <circle
          cx="${p0[0]}"
          cy="${p0[1]}"
          r="4"
          fill="var(--gold-line)"
        />

        <circle
          cx="${p3[0]}"
          cy="${p3[1]}"
          r="4"
          fill="var(--gold-line)"
        />

        ${pinsMarkup}
      `;

      const chosen = this.selectedCharms.filter(Boolean).length;

      this.previewCaption.textContent = chosen === 0
        ? this.empyText
        : `${chosen} di ${this.numCharms} ${this.qtyText}`;
    }

    updateFooter() {
      /*
       * Lasciato intenzionalmente come nel tuo script.
       *
       * Qui puoi eventualmente riattivare la logica:
       *
       * const chosen = this.selectedCharms.filter(Boolean).length;
       *
       * const complete =
       *   this.numCharms > 0 &&
       *   chosen === this.numCharms;
       *
       * this.statusText.textContent = complete
       *   ? 'Collana completa: tutti i charm sono stati scelti.'
       *   : `${chosen} di ${this.numCharms} charm scelti — continua a personalizzare.`;
       *
       * this.continueBtn.disabled = !complete;
       */
    }
  }

  customElements.define('nwt-neckl-charms', nwtNeckLCharms);
}
